import React from 'react';
import dogImg from '../../images/CheckoutConfirmation/dog.png';
import dogPawIcon from '../../images/CheckoutConfirmation/dog-paw.svg';
import dogKissImg from '../../images/CheckoutConfirmation/dog-kiss.png';
import ollieBoxIcon from '../../images/CheckoutConfirmation/ollie-box.svg';
import instagramIcon from '../../images/SocialMediaIcons/instagram.svg';
import tiktokIcon from '../../images/SocialMediaIcons/tiktok.svg';
import facebookIcon from '../../images/SocialMediaIcons/facebook.svg';
import twitterIcon from '../../images/SocialMediaIcons/twitter.svg';
import spotifyIcon from '../../images/SocialMediaIcons/spotify.svg';
import pinterestIcon from '../../images/SocialMediaIcons/pinterest.svg';
import { SplitPanelBody } from '../../components';
import { Referral } from './Referral';

export const splitPanels = [
  {
    image: {
      alt: `Dog`,
      src: dogImg.src,
    },
    backgroundColor: `hero.spinach`,
    alignImage: 'right',
    centered: false,
    content: (
      <SplitPanelBody
        heading={`Refer and Earn $40`}
        body={
          <>
            <p>
              When you refer your friends to Ollie, they get a free box of food,
              and you get a $40 account credit.
            </p>
            <Referral />
          </>
        }
        icon={{
          alt: 'Dog Paw - Refer and Earn',
          src: dogPawIcon.src,
        }}
      />
    ),
  },
  {
    content: (
      <SplitPanelBody
        icon={{
          alt: 'Dog',
          src: ollieBoxIcon.src,
        }}
        heading={`Welcome to the pack`}
        body={
          <p>
            Join our community and tag #MyOllie to show us us what you and your
            pup are up to.
          </p>
        }
        socialMediaIcons={[
          {
            src: instagramIcon.src,
            alt: 'Instagram',
            url: 'https://www.instagram.com/ollie/',
          },
          {
            src: facebookIcon.src,
            alt: 'Facebook',
            url: 'https://www.facebook.com/MyOllie',
          },
          {
            src: twitterIcon.src,
            alt: 'Twitter',
            url: 'https://twitter.com/olliepets',
          },
          {
            src: tiktokIcon.src,
            alt: 'Tiktok',
            url: 'https://www.tiktok.com/@olliepets',
          },
          {
            src: pinterestIcon.src,
            alt: 'Pinterest',
            url: 'https://www.pinterest.com/myolliedotcom/',
          },
          {
            src: spotifyIcon.src,
            alt: 'Spotify',
            url: 'https://open.spotify.com/user/ski5m70d8oulhj06d5ss6w1xm',
          },
        ]}
      />
    ),
    image: {
      alt: `Dog`,
      src: dogKissImg.src,
    },
    backgroundColor: `secondary.egg`,
    alignImage: 'left',
    centered: false,
  },
];
